module.exports = __webpack_public_path__ + "static/media/user_icon.600cdd69.svg";